<app-header [cartCount]="productService.getLocalCartProductLength()"></app-header>

<div class="mx-auto p-4 bg-gradient-to-br from-gray-50 to-white font-sans">
    <div class="flex items-center gap-3 mb-2">
      <div
        class="w-10 h-10 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center shadow-md">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
        </svg>
      </div>
      <div>
        <h1 class="text-2xl font-bold text-gray-900">Order History</h1>
        <!-- <p class="text-gray-600 text-sm">Where should we send your order?</p> -->
      </div>
    </div>
    <div class="h-1 w-24 bg-gradient-to-r from-orange-500 to-orange-400 rounded-full"></div>
</div>

<div id="table-container" class="w-[98%] mx-auto py-2">
  <!-- Grid Layout: 1 card on mobile, 4-5 cards on desktop -->
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-3">

    <!-- Order Card - Compact Version -->
    <div *ngFor="let order of dataSource.data; let i = index"
      class="bg-white rounded-lg shadow hover:shadow-md transition-shadow duration-200 border border-gray-100 flex flex-col h-full">

      <!-- Compact Header -->
      <div class="bg-gradient-to-r from-gray-50 to-gray-100/50 px-3 py-2 border-b border-gray-200">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-2 min-w-0">
            <div class="bg-blue-100 p-1.5 rounded flex-shrink-0">
              <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path>
              </svg>
            </div>
            <div class="truncate">
              <span class="text-xs text-gray-500">Order</span>
              <p class="text-sm font-semibold text-gray-800 truncate">#{{ order.orderNo }}</p>
            </div>
          </div>

          <!-- Status Badge - Compact -->
          <span class="px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap" [ngClass]="{
                  'bg-green-100 text-green-800': order.trackingStatus === 'Delivered',
                  'bg-yellow-100 text-yellow-800': order.trackingStatus === 'Accepted',
                  'bg-blue-100 text-blue-800': order.trackingStatus === 'Shipped',
                  'bg-gray-100 text-gray-800': order.trackingStatus === 'Processing'
                }">
            {{ order.trackingStatus }}
          </span>
        </div>

        <!-- OTP - Compact -->
        <div *ngIf="order.trackingStatus != 'Delivered'"
          class="mt-1 flex items-center bg-orange-50 px-2 py-1 rounded-md">
          <span class="text-xs font-medium text-orange-700">OTP:</span>
          <span class="ml-1 font-mono font-bold text-orange-800 text-xs">{{ order.otp }}</span>
        </div>
      </div>

      <!-- Compact Content -->
      <div class="px-3 py-2 bg-white flex-grow">
        <!-- Product Names - 2 lines max -->
        <div class="bg-gray-50 rounded p-2 mb-2">
          <p class="text-xs text-gray-500 mb-0.5">Products</p>
          <p class="text-xs text-gray-800 line-clamp-2 leading-relaxed">{{ getProductNames(order) }}</p>
        </div>

        <!-- Ratings - Compact -->
        <div *ngIf="order.trackingStatus == 'Delivered'" class="space-y-1.5">
          <div *ngIf="order.trackingStatus == 'Delivered'"
            class="flex items-center justify-between bg-purple-50 rounded px-2 py-1.5">
            <span class="text-xs font-medium text-purple-700">Location</span>
            <ngb-rating [formControl]="locationRateValue" [readonly]="order.deliveryFeedBackWebDto?.toLocation > 0"
              [max]="5" (click)="onLocationRateChange(order)" [(rate)]="order.deliveryFeedBackWebDto.toLocation"
              class="text-yellow-400 text-sm">
            </ngb-rating>
          </div>

          <div *ngIf="order.trackingStatus == 'Delivered' && order.customerDeliveryDetails"
            class="flex items-center justify-between bg-blue-50 rounded px-2 py-1.5">
            <span class="text-xs font-medium text-blue-700">Rider</span>
            <ngb-rating [formControl]="deliveryRateValue" [readonly]="order.deliveryFeedBackWebDto?.toDeliveryBoy > 0"
              [max]="5" (click)="onDeliveryRateChange(order)" [(rate)]="order.deliveryFeedBackWebDto.toDeliveryBoy"
              class="text-yellow-400 text-sm">
            </ngb-rating>
          </div>
        </div>
      </div>

      <!-- Compact Tabs -->
      <div class="border-t border-gray-200 mt-auto">
        <!-- Tab Navigation - Scrollable on mobile -->
        <div class="overflow-x-auto hide-scrollbar">
          <ul class="flex text-xs font-medium divide-x divide-gray-200" role="tablist">
            <li class="flex-1" (click)="toggleTab(i, 'order')">
              <button class="w-full py-2 px-1 text-center transition-colors whitespace-nowrap" [ngClass]="{
                        'text-blue-600 bg-blue-50 font-semibold': selectedTab[i] == 'order',
                        'text-gray-600 hover:bg-gray-50': selectedTab[i] != 'order'
                      }">
                Order
              </button>
            </li>
            <li class="flex-1" (click)="toggleTab(i, 'productDetails')">
              <button class="w-full py-2 px-1 text-center transition-colors whitespace-nowrap" [ngClass]="{
                        'text-blue-600 bg-blue-50 font-semibold': selectedTab[i] == 'productDetails',
                        'text-gray-600 hover:bg-gray-50': selectedTab[i] != 'productDetails'
                      }">
                Products
              </button>
            </li>
            <li class="flex-1" (click)="toggleTab(i, 'shipping')">
              <button class="w-full py-2 px-1 text-center transition-colors whitespace-nowrap" [ngClass]="{
                        'text-blue-600 bg-blue-50 font-semibold': selectedTab[i] == 'shipping',
                        'text-gray-600 hover:bg-gray-50': selectedTab[i] != 'shipping'
                      }">
                Shipping
              </button>
            </li>
            <li class="flex-1" (click)="toggleTab(i, 'invoice')">
              <button class="w-full py-2 px-1 text-center transition-colors whitespace-nowrap" [ngClass]="{
                        'text-blue-600 bg-blue-50 font-semibold': selectedTab[i] == 'invoice',
                        'text-gray-600 hover:bg-gray-50': selectedTab[i] != 'invoice'
                      }">
                Invoice
              </button>
            </li>
            <li class="flex-1" (click)="toggleTab(i, 'status'); onStatusClick(order)">
              <button class="w-full py-2 px-1 text-center transition-colors whitespace-nowrap" [ngClass]="{
                        'text-blue-600 bg-blue-50 font-semibold': selectedTab[i] == 'status',
                        'text-gray-600 hover:bg-gray-50': selectedTab[i] != 'status'
                      }">
                Status
              </button>
            </li>
          </ul>
        </div>

        <!-- Tab Content - Compact Dropdown Style -->
        <div class="p-3 bg-gray-50 border-t border-gray-200 text-xs max-h-64 overflow-y-auto">

          <!-- Order Details Tab -->
          <div *ngIf="selectedTab[i] == 'order'" class="animate-fadeIn">
            <div class="space-y-1.5">
              <div class="flex justify-between">
                <span class="text-gray-500">Date:</span>
                <span class="text-gray-800 font-medium">{{ order.createdDate | date: 'dd/MM/yy HH:mm' }}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-gray-500">Order Amt:</span>
                <span class="text-green-600 font-semibold">{{ order.totalAmount | currency: 'INR' }}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-gray-500">Shipping:</span>
                <span class="text-gray-800">{{ (order.shippingDetails?.totalAmount || 0) | currency: 'INR' }}</span>
              </div>
              <div class="flex justify-between pt-1 border-t border-gray-200">
                <span class="text-gray-700 font-medium">Total:</span>
                <span class="text-blue-600 font-bold">{{ order.totalAmount + order.shippingDetails?.totalAmount |
                  currency: 'INR' }}</span>
              </div>
              <div class="mt-1 text-gray-600 truncate"
                title="{{order.location?.locationName}}, {{order.location?.address}}">
                <span class="text-gray-500">📍</span> {{order.location?.locationName}}, {{order.location?.pin}}
              </div>
            </div>
          </div>

          <!-- Product Details Tab - Compact Grid -->
          <div *ngIf="selectedTab[i] == 'productDetails'" class="animate-fadeIn">
            <div class="space-y-2 max-h-48 overflow-y-auto">
              <div *ngFor="let element of order.webOrderDetails" class="border-b border-gray-200 pb-1.5 last:border-0">
                <p class="font-semibold text-gray-800 text-xs truncate">{{ element.productName }}</p>
                <div class="flex justify-between mt-0.5">
                  <span class="text-gray-500">Qty: {{ element.qty }} × {{ element.rate | number:'1.0-0' }}</span>
                  <span class="font-medium text-green-600">{{ (element.qty * element.rate) | currency:'INR' }}</span>
                </div>
                <p class="text-gray-500 text-xs italic truncate">{{ element.message || 'No message' }}</p>
              </div>
            </div>
          </div>

          <!-- Shipping Details Tab - Compact -->
          <div *ngIf="selectedTab[i] == 'shipping'" class="animate-fadeIn">
            <div class="space-y-1.5">
              <div class="flex justify-between">
                <span class="text-gray-500">Customer:</span>
                <span class="text-gray-800 font-medium truncate ml-2">{{ order.customerDeliveryDetails?.contactName ||
                  order.customer?.customerName }}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-gray-500">Mobile:</span>
                <span class="text-gray-800">{{ order.customerDeliveryDetails?.contactMobile ||
                  order.customer?.customerMobile }}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-gray-500">Delivery:</span>
                <span class="text-gray-800">{{ order.deliveryDate }} {{ order.deliveryTime }}</span>
              </div>
              <div class="mt-1">
                <span class="text-gray-500">Address:</span>
                <p class="text-gray-600 text-xs mt-0.5 leading-relaxed">
                  {{ order.customerDeliveryDetails?.shippingAddress || 'NA' }},
                  {{ order.customerDeliveryDetails?.shippingPlotNo || '' }},
                  {{ order.customerDeliveryDetails?.shippingStreet || '' }}
                </p>
                <p class="text-gray-600 text-xs mt-0.5">
                  {{ order.customerDeliveryDetails?.shippingCity?.cityName || 'NA' }} - {{
                  order.customerDeliveryDetails?.shippingPinCode || 'NA' }}
                </p>
              </div>
            </div>
          </div>

          <!-- Invoice Details Tab - Compact -->
          <div *ngIf="selectedTab[i] == 'invoice'" class="animate-fadeIn">
            <div class="space-y-2">
              <div class="flex items-center justify-between p-1.5 bg-blue-50 rounded">
                <span class="text-xs text-gray-700">Order:</span>
                <a [routerLink]=""
                  (click)="generateInvoice(order.location?.refNo, order.invoiceDetails[0]?.invoiceNo, order.invoiceDetails[0]?.invoiceType)"
                  class="inline-flex items-center px-2 py-1 bg-white border border-blue-300 rounded hover:bg-blue-100 transition-colors text-xs">
                  <span class="text-blue-600 font-medium truncate max-w-[80px]">{{ order.invoiceDetails[0]?.invoiceNo
                    }}</span>
                  <svg class="w-3 h-3 ml-1 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
                  </svg>
                </a>
              </div>

              <div *ngIf="order.shippingDetails?.invoiceDetails[0]?.invoiceNo"
                class="flex items-center justify-between p-1.5 bg-green-50 rounded">
                <span class="text-xs text-gray-700">Shipping:</span>
                <a [routerLink]=""
                  (click)="generateInvoice(order.location?.refNo, order.shippingDetails?.invoiceDetails[0]?.invoiceNo, order.shippingDetails?.invoiceDetails[0]?.invoiceType)"
                  class="inline-flex items-center px-2 py-1 bg-white border border-green-300 rounded hover:bg-green-100 transition-colors text-xs">
                  <span class="text-green-600 font-medium truncate max-w-[80px]">{{
                    order.shippingDetails?.invoiceDetails[0]?.invoiceNo }}</span>
                  <svg class="w-3 h-3 ml-1 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          <!-- Status Tab - Mini Stepper -->
          <div *ngIf="selectedTab[i] == 'status'" class="animate-fadeIn">
            <div class="space-y-2">
              <!-- Mini Vertical Stepper -->
              <div class="relative pl-4 space-y-2">
                <div *ngFor="let status of order.statusList; let j = index" class="relative flex items-start">
                  <!-- Step Dot -->
                  <div class="absolute left-[-12px] top-1.5 w-2 h-2 rounded-full" [ngClass]="{
                         'bg-green-500': j < stepperStatus[order.orderNo],
                         'bg-blue-500 ring-2 ring-blue-200': j === stepperStatus[order.orderNo],
                         'bg-gray-300': j > stepperStatus[order.orderNo]
                       }">
                  </div>
                  <!-- Connector Line -->
                  <div *ngIf="j !== order.statusList.length - 1" class="absolute left-[-9px] top-3 w-0.5 h-4" [ngClass]="{
                         'bg-green-400': j < stepperStatus[order.orderNo] - 1,
                         'bg-gray-200': j >= stepperStatus[order.orderNo] - 1
                       }">
                  </div>

                  <div class="ml-1">
                    <p class="text-xs font-medium" [ngClass]="{
                         'text-green-600': j < stepperStatus[order.orderNo],
                         'text-blue-600': j === stepperStatus[order.orderNo],
                         'text-gray-400': j > stepperStatus[order.orderNo]
                       }">
                      {{ status }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Cancel Order Button - Compact -->
              <!-- <button *ngIf="order.trackingStatus == 'Accepted' && order.invoiceDetails[0]?.invoiceType == 'Make To Order'"
                      (click)="onOrderCancelClick(order)"
                      class="mt-2 w-full px-3 py-1.5 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-medium rounded-md text-xs transition-all duration-200 flex items-center justify-center">
                <svg class="w-3.5 h-3.5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
                Cancel Order
              </button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Hide scrollbar utility -->
<style>
  .hide-scrollbar::-webkit-scrollbar {
    display: none;
  }

  .hide-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(5px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .animate-fadeIn {
    animation: fadeIn 0.2s ease-out;
  }

  .line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
</style>